export const labelMenu = {
  //Note: Define value must match to name in language file
  DASHBOARD: 'dashboard',

  MY_PAGE: 'my_page',
  TIMESHEET: 'timesheet',
  TIMEKEEPING: 'timekeeping',
  PAYSLIP: 'payslip',
  CONTRACT: 'contract',
  DEVICE: 'device',
  ON_OFF_BOARD: 'on_off_board',
  ONBOARD: 'onboard',
  OFFBOARD: 'offboard',
  OBSERVATION_LIST: 'observation_list',

  EMPLOYEE_MANAGE: 'employee_manage',

  WATCHING_LIST_MANAGER_REQUEST_LIST: 'watching_list_manager_request_list',
  WATCHING_LIST_HR_REQUEST_LIST: 'watching_list_hr_request_list',
  WATCHING_LIST: 'watching_list',
  WATCHING_LIST_MANAGE: 'watching_list_manage',

  TIMESHEET_MANAGE: 'timesheet_manage',
  TIMESHEET_REQUEST_APPROVAL: 'timesheet_request_approval',
  TIMESHEET_REQUEST_PENDING: 'timesheet_request_pending',
  TIMESHEET_APPROVAL: 'timesheet_approval',
  TIMESHEET_EMPLOYEE_TIMESHEET: 'timesheet_employee_timesheet',

  ON_OFF_BOARD_MANAGE: 'onoffboard_manage',
  ONBOARD_EMPLOYEE: 'onboard_employee',
  OFFBOARD_EMPLOYEE: 'offboard_employee',
  INSURANCE_MANAGE: 'insurance_manage',
  INSURANCE_COMPLUSURY_LIST: 'insurance_complusory_list',
  INSURANCE_SETTING: 'insurance_setting',

  PAYROLL: 'payroll',
  VIEW_EMPLOYEE_INFO: 'view_employee_info',

  CONTRACT_MANAGE: 'contract_manage',
  CONTRACT_TEMPLATE: 'contract_template',
  CONTRACT_EMPLOYEE: 'contract_employee',

  EQUIPMENT_MANAGE: 'equipment_manage',
  EQUIPMENT_INVENTORY_CONTROL: 'equipment_inventory_control',
  EQUIPMENT_HANDOVER: 'equipment_handover',

  CONFIGURATION: 'configuration',
  CONFIGURATION_CATEGORY: 'configuration_category',
  CONFIGURATION_DEPARTMENT: 'configuration_department',
  CONFIGURATION_POSITION: 'configuration_position',
  CONFIGURATION_ROLE: 'configuration_role',
  CONFIGURATION_WORKSHIFT: 'configuration_workshift',
  CONFIGURATION_PAYROLL: 'configuration_payroll',
  CONFIGURATION_STATUS: 'configuration_status',
  CONFIGURATION_WORKFLOW_TYPE: 'configuration_workflow_type',
  CONFIGURATION_ACTION: 'configuration_action',

  CONFIGURATION_SETUP_POLICY: 'configuration_setup_policy',
  CONFIGURATION_WORK_SHIFTS: 'configuration_work_shifts',
  CONFIGURATION_SETUP_WORK_SHIFTS: 'configuration_setup_work_shifts',
  CONFIGURATION_MANAGE_WORK_SHIFTS: 'configuration_manage_work_shifts',
  LEAVE_OFF: 'leave_off',
  MANAGE_LEAVE_OFF: 'manage_leave_off',

  MANAGE_PROJECT: 'manage_project',
  MANAGE_PROJECT_HISTORY: 'manage_project_history',
  MANAGE_OVERTIME: 'manage_overtime',
  OVERTIME_PLAN_REQUEST: 'overtime_plan_request',
  OVERTIME_PLAN_REQUEST_HISTORY: 'overtime_plan_request_history',
  OVERTIME_APPROVAL: 'overtime_approval',
  OVERTIME_APPROVAL_HISTORY: 'overtime_approval_history',
  MANAGE_OVERTIME_TYPE: 'manage_overtime_type',

  MANAGE_INSURANCE: 'manage_insurance',
  COMPLUSURY_INSURANCE_LIST: 'complusory_insurance_list',
  SETTING_INSURANCE: 'setting_insurance',
  CONFIGURATION_SETUP_WORKFLOW: 'configuration_setup_workflow',
  CONFIGURATION_SETUP_MENU_SCREEN: 'configuration_setup_menu_screen',

  // mail & notification settings
  CONFIGURATION_MANAGE_MAIL_AND_NOTIFICATION: 'configuration_mail_&_notification',
  CONFIGURATION_MANAGE_MAIL_TEMPLATES: 'configuration_mail_templates',
  CONFIGURATION_MANAGE_SEND_MAIL: 'configuration_send_mail',
  CONFIGURATION_MANAGE_AUTO_SEND_MAIL: 'configuration_auto_send_mail',
  CONFIGURATION_MANAGE_NOTIFICATION: 'configuration_email_server',

  CONFIGURATION_GENERAL: 'configuration_general',

  PRODUCT_MANAGE: 'product',

  REPORT: 'Report',
};
